import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import {Observable} from 'rxjs/Observable';

/*
  Generated class for the CustomSplashHandlerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class CustomSplashHandlerProvider {
	observers: any = [];
	subscription: any;

	constructor(public http: Http) {
		this.subscription = Observable.create(observer => {
		  this.observers.push(observer);
		});		
	}

	setMessage(params){
      console.log("Set message params");
      console.log(params  );
      console.log("Observer count");
      console.log(this.observers.length);
  		if(this.observers){
          setTimeout(()=>{        
  			    for (var i = this.observers.length - 1; i >= 0; i--) {
              this.observers[i].next(params);
  			    }
          }, 500)
  		}			
	}
}



// WEBPACK FOOTER //
// ./src/providers/custom-splash-handler.ts